import { type OpenClosedState, useOpenClosedState } from './useOpenClosedState';
import { type TransitionState, useTransition } from './useTransition';

interface Params {
    initialState?: boolean;
    onOpened?: () => void;
    onClosed?: () => void;
    transitionDuration?: number;
    appear?: boolean;
}

export interface ModalTransitionState extends OpenClosedState, TransitionState {
    isOpen: boolean;
    isClosed: boolean;
}

export function useModalTransitions(params: Params = {}): ModalTransitionState {
    const { appear, transitionDuration, onOpened, onClosed } = params;
    const initialState = params.initialState ?? false;

    const modal = useOpenClosedState({ initialState });
    const transition = useTransition(modal.isOpen, {
        appear,
        transitionDuration,
        onOpened,
        onClosed,
    });

    return {
        open: modal.open,
        close: modal.close,
        toggle: modal.toggle,
        stage: transition.stage,
        isOpen: transition.stage === 'open' || transition.stage === 'opening',
        isClosed: transition.stage === 'closed' || transition.stage === 'closing',
        isMounted: transition.isMounted,
    };
}
